// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 11V9H11V11H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 11V9H15V11H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 13H15L15 15H13V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 13V15H9L9 13H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM9 7H11V6H13V7H15V6H17V7H18V9H17V11H18V13H17V15H18V17H17L17 18H15V17H13V18H11V17H9V18H7L7 17H6V15H7V13H6V11H7V9H6V7H7V6H9V7Z"}}]};

const MapGridFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-grid-filled',
    ref,
    icon: element,
  },
));

MapGridFilledIcon.displayName = 'MapGridFilledIcon';

export default MapGridFilledIcon;
